<template>
    <div>
        <h2>에러가 발생했습니다. 잠시 후 새로고침 해주세요.</h2>
    </div>
</template>

<script>
    export default {
        name: 'Cafe24ErrorView',
    };
</script>

<style lang="scss" scoped>

</style>